import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "resources-header",
  class: "w-100"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "resources-header-text",
    class: "static-large text-blue"
  }, [
    /*#__PURE__*/_createTextVNode(" Autism"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Resources ")
  ])
], -1)
const _hoisted_2 = {
  id: "resources-links",
  class: "back-blue"
}
const _hoisted_3 = { class: "text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkList = _resolveComponent("LinkList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (section, sectionKey) => {
        return (_openBlock(), _createElementBlock("div", {
          key: sectionKey,
          class: "list-section mlr-auto"
        }, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.makeTitle(sectionKey)), 1),
          _createVNode(_component_LinkList, {
            class: "flex column",
            "link-section": section,
            "text-color-class": 'text-link-yellow',
            internal: false
          }, null, 8, ["link-section"])
        ]))
      }), 128))
    ])
  ]))
}